'use strict'

const pullPushable = require('pull-pushable')
const pullWrite = require('pull-write')

module.exports = function createBuildStream (createStrategy, ipldResolver, options) {
  const source = pullPushable()

  const sink = pullWrite(
    createStrategy(source),
    null,
    options.highWaterMark,
    (err) => source.end(err)
  )

  return {
    source: source,
    sink: sink
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/ipfs-unixfs-engine/src/builder/create-build-stream.js
// module id = 487
// module chunks = 0